
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rezerwuj/[id]",
      function () {
        return require("private-next-pages/rezerwuj/[id].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rezerwuj/[id]"])
      });
    }
  